// extracted by mini-css-extract-plugin
export default {"icon":"product-availability-icon__icon___2tO8h","icon-unavailable":"product-availability-icon__icon-unavailable___2G6nn"};